import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { Button } from '../Button';
import styles from './styles.module.scss';

interface AlertDialogProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  destructive?: boolean;
}

const CustomAlertDialog = ({
    children,
    title,
    subtitle,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    destructive = false,
}: AlertDialogProps) => {
    return (
        <AlertDialog.Root>
            <AlertDialog.Trigger asChild>
                {children}
            </AlertDialog.Trigger>
            <AlertDialog.Portal>
                <AlertDialog.Overlay className={styles.overlay} />
                <AlertDialog.Content className={styles.content}>
                    <div className={styles.header}>
                        <AlertDialog.Title className={styles.title}>
                            {title}
                        </AlertDialog.Title>
                        {subtitle ? (
                            <AlertDialog.Description className={styles.subtitle}>
                                {subtitle}
                            </AlertDialog.Description>
                        ) : null}
                    </div>
                    <div className={styles.actions}>
                        <AlertDialog.Action asChild>
                            <Button
                                color="alert"
                                variant="outline"
                                size="2"
                                onClick={onConfirm}
                            >
                                {confirmText}
                            </Button>
                        </AlertDialog.Action>
                        <AlertDialog.Cancel asChild>
                            <Button 
                                size="2"
                                onClick={onCancel}
                            >
                                {cancelText}
                            </Button>
                        </AlertDialog.Cancel>
                    </div>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export default CustomAlertDialog;